import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthSlice, createAuthSlice } from './slices/auth.slice';
import { FilterSlice, createFilterSlice } from './slices/filter.slice';
import { UserSlice, createUserSlice } from './slices/user.slice';
import { partialize } from './persist/partialize';
import { GLOBAL_STORE_VERSION } from './persist/version';

export type GlobalStore = AuthSlice & FilterSlice & UserSlice;

export const useGlobalStore = create<GlobalStore>()(
  persist(
    (...a) => ({
      ...createAuthSlice(...a), // prefix: `auth_`
      ...createFilterSlice(...a), // prefix: `filter_`
      ...createUserSlice(...a), // prefix: `user_`
    }),
    {
      name: 'SILOREAL.WEB.GLOBAL_STORE',
      partialize,
      version: GLOBAL_STORE_VERSION,
    }
  )
);
